import { render, staticRenderFns } from "./TenementBuilding.vue?vue&type=template&id=65477d8e&"
import script from "./TenementBuilding.vue?vue&type=script&lang=ts&"
export * from "./TenementBuilding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports